import { PageRef } from '@wix/document-services-types';
import { PlatformApiEnhancerFunction } from '../../../types/platformApi';
import {
  addVariantToPage,
  getVariantPageRule,
  updateVariantPageRule,
  replaceAppPageWithReplacerPage,
} from '../../services/pageReplaceService/pageReplaceService';
import { Rule } from '@wix/editor-platform-sdk-types';

export const pageReplaceEnhancer: PlatformApiEnhancerFunction = (
  platformApiMethods,
  { documentServices },
) => {
  return {
    editor: {
      routers: {
        addVariantToPage: (
          pageRef: PageRef,
          variantPageRef: PageRef,
          rule: any,
          variantId: string,
          biFlowId?: string,
        ) => {
          addVariantToPage(documentServices, {
            pageRef,
            variantPageRef,
            rule,
            variantId,
            biFlowId,
          });
        },
        getVariantPageRule: (variantPageRef: PageRef) =>
          getVariantPageRule(documentServices, variantPageRef),
        updateVariantPageRule: (
          variantPageRef: PageRef,
          updatedRule: Rule,
          biFlowId?: string,
        ) =>
          updateVariantPageRule(documentServices, {
            variantPageRef,
            updatedRule,
            biFlowId,
          }),
        setReplacerPage: (pageRef: PageRef, replacerPageRef: PageRef) =>
          replaceAppPageWithReplacerPage(
            platformApiMethods,
            documentServices,
            pageRef,
            replacerPageRef,
          ),
      },
    },
  };
};
